// extracted by mini-css-extract-plugin
module.exports = {"alert":"Alert_alert__2JtCx","closeButton":"Alert_closeButton__1cVBD","alertProfile":"Alert_alertProfile__2oHXL"};